export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((error) => {
      // A failed service worker must never prevent the web app from working.
      console.warn("Matchium service worker registration failed", error);
    });
  });
}
